import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import { FormattedMessage } from '../../../components/I18n'; // @ts-expect-error Could not find a declaration file for module

import ExportDialog from 'ExportDialog/components/ExportDialog';
import { useUserInfo } from '../../../features/accounts';
import { ExportClient, ExportEmailFormField, ExportFormatFormField, createExportLanguageFormField } from '..';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import I18n from 'I18n';
import useToggle from '../../../hooks/useToggle';
import UsageTracker from '../../../utils/UsageTracker';

const useExportConfig = (exportType, extraData) => {
  const {
    userInfo
  } = useUserInfo();
  const userEmail = userInfo ? userInfo.user.emails[0] : '';
  return useMemo(() => {
    let formFields;
    let headerTextKey;

    switch (exportType) {
      case 'MY_TEAM':
        formFields = [ExportEmailFormField, ExportFormatFormField, createExportLanguageFormField()];
        headerTextKey = 'learningCenter.team.exportDialogHeader';
        break;

      case 'PLAYLIST_ASSIGNMENTS':
        formFields = [ExportEmailFormField, ExportFormatFormField, createExportLanguageFormField()];
        headerTextKey = 'learningCenter.playlistAssignments.exportDialogHeader';
        break;

      default:
        formFields = [];
        headerTextKey = 'learningCenter.common.export';
    }

    return {
      dialogConfig: {
        client: ExportClient(exportType, extraData),
        userEmail,
        formFields
      },
      headerTextKey
    };
  }, [exportType, extraData, userEmail]);
};

const ExportButton = (_ref) => {
  let {
    children = /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.common.export`
    }),
    use = 'tertiary-light',
    exportType
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "use", "exportType"]);

  const {
    isShowing,
    show,
    hide
  } = useToggle();

  const handleOpenExportDialog = () => show();

  const handleCloseExportDialog = () => hide();

  const handleSuccess = () => {
    FloatingAlertStore.addAlert({
      type: 'success',
      message: I18n.text('learningCenter.export.notificationBody'),
      titleText: I18n.text('learningCenter.export.notificationHeader')
    });
    UsageTracker.track('interaction', {
      action: 'export',
      type: exportType
    });
  };

  const {
    dialogConfig,
    headerTextKey
  } = useExportConfig(exportType);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isShowing && /*#__PURE__*/_jsx(ExportDialog, Object.assign({}, dialogConfig, {
      headerContents: /*#__PURE__*/_jsx(FormattedMessage, {
        message: headerTextKey
      }),
      onClose: handleCloseExportDialog,
      onSuccess: handleSuccess
    })), /*#__PURE__*/_jsx(UIButton, Object.assign({}, props, {
      onClick: handleOpenExportDialog,
      use: use,
      children: children
    }))]
  });
};

export default ExportButton;